// extracted by mini-css-extract-plugin
module.exports = {"project__content":"project-info-section_project__content__Lhz66"};